import { useEffect, useRef } from 'react';

const useSmoothAudioUpdate = (onUpdate: (time: number) => void) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const requestRef = useRef<number | null>(null);

  const updateAudioTime = () => {
    if (audioRef.current) {
      onUpdate(audioRef.current.currentTime);
    }
    requestRef.current = requestAnimationFrame(updateAudioTime);
  };

  useEffect(() => {
    if (audioRef.current) {
      requestRef.current = requestAnimationFrame(updateAudioTime);
    }

    return () => {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioRef.current]);

  return audioRef;
};

export default useSmoothAudioUpdate;
